import { type ComponentPropsWithoutRef, memo } from 'react';

import { Chip } from '@air/primitive-chip';
import { cn } from '@air/utils-tailwind';

export type PopularSmartTagsProps = Pick<ComponentPropsWithoutRef<'div'>, 'className'> & {
  onSmartTagClick: (smartTag: string) => void;
  smartTags: string[];
};

export const PopularSmartTags = memo(({ className, onSmartTagClick, smartTags }: PopularSmartTagsProps) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <h3 className="font-bold ads:text-metadata text-10 text-gray-9 uppercase tracking-wider">Popular Smart Tags</h3>
      <div className="flex flex-wrap gap-2">
        {smartTags.map((smartTag) => (
          <Chip
            asChild
            key={smartTag}
            // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the color pairing
            onClick={() => onSmartTagClick(smartTag)}
            shape="rounded"
            size="medium"
          >
            <button type="button">{smartTag}</button>
          </Chip>
        ))}
      </div>
    </div>
  );
});

PopularSmartTags.displayName = 'PopularSmartTags';
